class Elementor_Opal_MegaMenu {
    static instance;
           settings = {};
           $toggle;
           
           $dropdownMenu

    static getInstance() {
        if (!Elementor_Opal_MegaMenu.instance) {
            Elementor_Opal_MegaMenu.instance = new Elementor_Opal_MegaMenu();
        }
        return Elementor_Opal_MegaMenu.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }


    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-mega-menu.default', ($scope) => {
            this.setupToggleButton($scope);  
            this.setupMenu($scope);
        });
    }

    setupMenu($scope) {  
        if( $scope.find('nav.opalelementor-nav-menu--main .sub-menu').length > 0 ){ 
            let subMenusMinWidth = $scope.find('nav.opalelementor-nav-menu--main').data('submenusminwidth');
            let subMenusMaxWidth = $scope.find('nav.opalelementor-nav-menu--main').data('submenusmaxwidth');
            subMenusMaxWidth = 1000;
            $scope.find('.opalelementor-nav-menu').smartmenus({
                subIndicatorsText: '',
                subIndicatorsPos : 'append',
                subMenusMinWidth : subMenusMinWidth+'px',
                subMenusMaxWidth : subMenusMaxWidth+'px',
                // subMenusSubOffsetY: 100,
                showTimeout      : 0
            }); 
        }    
    }

    setupToggleButton($scope) {
        if (this.isMobileMenu($scope)) {
            // Code Button
            $scope.$toggle = $scope.find('.opalelementor-menu-toggle');
            $scope.$toggle.on('click', () => { 

                this.$dropdownMenu = $scope.find('.opalelementor-nav-menu--dropdown.opalelementor-nav-menu__container');
                $scope.$toggle.toggleClass('opalelementor-active');
                this.toggleMenu($scope, $scope.$toggle.hasClass('opalelementor-active'));
            });
        }
    }

    isMobileMenu($scope) {
        return $scope.find('.opalelementor-menu-toggle').length > 0;
    }

    toggleMenu($scope, show) {
        let $dropdownMenu = this.$dropdownMenu;
        let settings      = $scope.data('settings');
        if (show) {
            $dropdownMenu.hide().slideDown(250, function () {
                $dropdownMenu.css('display', '');
            });

            if (settings.full_width) {
                $dropdownMenu.css(this.menuFullWidth($scope, $dropdownMenu));
            }

        } else {
            $dropdownMenu.show().slideUp(250, function () {
                $dropdownMenu.attr('style', '');
            });
        }
    }

    menuFullWidth($scope, $dropdownMenu) {
        let $container     = $(window),
            containerWidth = $container.outerWidth(),
            elementOffset  = $dropdownMenu.offset().left;

        return {
            'top'  : $scope.$toggle.outerHeight(),
            'left' : -elementOffset + 'px',
            'width': containerWidth,
        }
    }
}
Elementor_Opal_MegaMenu.getInstance(); 